<template>
  <!-- eslint-disable max-len -->
  <div class="root">
    <div v-if="!loading" class="content mobile-adjust">
      <div class="login-card mobile-adjust">
        <div class="login-card-background" />
        <div class="login-form-container">
          <div class="login-title form-element">set new password</div>
          <input
            ref="password"
            class="form-element form-control"
            :style="$v.password.$error ? validationFailedStyle : ''"
            placeholder="Enter Password"
            v-model.trim="password"
            :validator="$v.password"
            @input="allowValidationErrors=true"
            @blur="()=>{ if (allowValidationErrors) $v.password.$touch() }"
            type="password"
          />

          <div class="login-form-footer">
            <div class="login-form-login-button-container form-element">
              <button
                type="submit"
                class="btn login-btn lgn-lg-btn"
                @click.prevent="onSubmit"
                :disabled="submitting || $v.$invalid">
                Set New Password
              </button>
            </div>
          </div>
          <div class="error-container">
            <template v-if="$v.password.$error">
              <div class="error-msg" v-if="!$v.password.required">Password is required</div>
              <div class="error-msg" v-else-if="!$v.password.minLength">Password must be {{ $v.password.$params.minLength.min }} characters or more</div>
              <div class="error-msg" v-else-if="!$v.password.maxLength">Password must be {{ $v.password.$params.maxLength.max }} characters or less</div>
            </template>
          </div>
        </div>
      </div>
      <div class="login-card">
        <div class="login-card-background" :style="brandBackgroundStyle" />
        <div class="login-brand-container">
          <div class="brand-top">
            <div class="brand-image" :style="`background-image: url('${brandImage}');`" />
          </div>
          <div style="border: 1px solid white;"/>
          <div class="brand-bottom">
            {{resetSuccess ? 'Password successfully changed!' : 'Specify new password.'}} <router-link to="/signin" style="color: rgb(225, 225, 255);">Click here to login.</router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      LOADING
      <!-- TODO SPINNER -->
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      password: '',
      submitting: false,
      resetSuccess: false
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeSignInConfig',
      'classTypeNameLower',
      'me',
    ]),
    validationFailedStyle() {
      return 'box-shadow: 0 0 2px red; background-color: rgba(255, 0, 0, 0.1);';
    },
    brandBackgroundStyle() {
      return {
        'background-color': this.activeSignInConfig.brandPrimaryColor
      };
    },
    brandImage() {
      return this.resolveAssetPath(this.activeSignInConfig.midsectionImage, 'ui/customer');
    },
    brandText() {
      return this.activeSignInConfig.midsectionText || 'RedmerU is a hosting platform for digital case studies also known as “gamulations” for academic use in higher education institutions. These applications provide an experiential learning experience for college students both in the classroom and from home in a distance learning environment.';
    }
  },
  methods: {
    ...mapActions([
      'resetPassword',
      'flashDanger',
      'flashSuccess',
    ]),

    async onSubmit() {
      if (this.$v.$invalid || this.submitting) return;
      this.submitting = true;

      try {
        const { password } = this;
        const id = this.$route.params.code;
        await this.resetPassword({ id, newPassword: password });
        this.resetSuccess = true;
        const message = 'Password reset successful! Redirecting to login...';
        this.flashSuccess({ message, modal: true, onCloseModal: () => { this.$router.replace('/signin'); } });
      } catch (err) {
        console.log(err);
        const message = 'Password reset unsuccessful';
        this.flashDanger({ message, modal: true });
        this.submitting = false;
        this.$refs.password.focus();
      }
    },

    home() {
      this.$router.home();
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(128)
    }
  }
};
</script>

<style lang="scss" scoped>
.signin-form {
  width: 75%;
  position: absolute;
  left: 30px;
  top: 110px;

  .title {
    width: 100%;
    margin-bottom: 6px;
    font-size: 95%;
  }

  .error-msg {
    color: var(--signInTextColor);
    font-size: 85%;
    margin-top: 7px;
    margin-bottom: 7px;
  }

  input {
    background-color: #99999933;
    opacity: .9;
    border: 1px solid #dddddd;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #dddddd;
  }

  input::placeholder {
    color: #bbbbbb;
    text-transform: lowercase;
  }

  .login-btn {
    width: 42%;
  }

  .pw-reset-btn {
    padding: 5px;
  }

  .forgot-pw-btn {
    padding: 5px;
    filter: saturate(0.2);
  }
}

.loader {
  border: 4px solid #f3f3f3aa;
  border-top: 4px solid #44484baa;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: auto;
  animation: spin .75s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.root {
  // 40px == the navbar height.  If that changes, change this.
  height: calc(100vh - 40px);
  background-size: cover;
  width: 100%;
  position: relative;
  font-weight: 100;
}

.content {
  input {
    color: rgb(34, 34, 34);
  }
  // color: var(--signInTextColor);
  color: rgb(34,34,34);
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;

  height: 45%;
  width: 100%;
  // padding-left: 22%;
  // padding-right: 22%;
  position: absolute;
  top: 15%;
}

@media only screen and (max-width: 757px)  {
  .content.mobile-adjust {
    top: 0 !important;
  }
}

.login-card {
  position: relative;
  min-width: calc(min(350px, 98vw));
  min-height: 450px;
  margin: 10px;
  width: 25%;
  height: 100%;
  border-radius: 15px;
  border: 2px solid white;
  overflow: hidden;
}

@media only screen and (max-width: 757px)  {
  .login-card.mobile-adjust {
    min-height: 0 !important;
    height: fit-content !important;
  }
}

.login-card-background {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;

  background-color: white;
  mask-image: url('/static/ui/customer/EA1_loginBox-White.png');
  mask-size: 110% 110%;
  mask-position: center;
}

.login-form-container
{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
  overflow-y: auto;
}

.login-form-footer
{
  display: flex;
  justify-content: space-between;
}

.login-form-login-button-container
{
  display: flex;
  justify-content: flex-end;
}

.login-brand-container
{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 20px;
  overflow-y: auto;
  color: white;
}

.brand-top
{
  height: 48%;
}

.brand-bottom
{
  height: 48%;
  font-size: 18px;
}

.brand-image
{
  position: relative;
  width: 100%;
  height: 100%;
  padding: 30px;
  background-origin: content-box;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.lgn-lg-btn
{
  font-size: 18px;
  min-width: 100px;
  height: 40px;
  padding: 5px;
}

.login-title
{
  font-size: 30px;
  text-transform: uppercase;
  font-weight: 50;
}

.form-element
{
  margin: 5px 0;
}

.error-container
{
  margin-top: 5px;
  height: 20px;
}

.error-msg
{
  color: darkred;
  font-weight: 500;
}

.brand-bottom
{
  color: var(--signInTextColor);
}

.eula-prompt-container
{
  position: fixed;
  top: calc(20vh - 15px);
}
</style>



// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue